/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-param-reassign */
import { useCart } from 'models/cart';
import { useStock } from 'models/stock';

export const useProductStock = (
	productType: 'combination' | 'normal',
	id: number,
	products?: number[] | undefined,
) => {
	const [{ allProductStock }] = useStock();
	const [{ apiData }] = useCart();

	if (productType !== 'combination') {
		const countFromApi = apiData?.normal[id!] ?? 0;
		const stock = allProductStock.get(id || 0) || 0;
		return stock + countFromApi > 0 ? stock + countFromApi : 0;
	}
	const countFromApi = apiData?.combination[id!] ?? 0;
	const stock =
		products?.reduce((acc, cur) => {
			acc = Math.min(acc, allProductStock.get(cur) || 0);
			return acc;
		}, Infinity) || 0;

	return stock + countFromApi > 0 ? stock + countFromApi : 0;
};
